import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading } from 'react-icons/ai';

import { Modal } from '../../../../components';
import { pxToRem } from '../../../../functions';
import { colors, fonts } from '../../../../theme';

const rotation = keyframes`
 to {
    transform: rotate(1turn);
  }
`;

export const Container = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  height: ${({ specialStyle }) => (specialStyle ? '100%' : 'auto')};
  padding: ${({ specialStyle }) =>
    specialStyle ? '0 0 0 39px' : '20px 20px 0'};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ specialStyle }) =>
    specialStyle ? 'flex-start' : 'center'};

  > * {
    color: ${colors.eightGrey};
  }

  label {
    margin-top: ${pxToRem(20)};
  }

  h1 {
    margin-top: ${pxToRem(20)};

    ${fonts.size6}
    line-height: 1.21;
    text-align: center;
    font-family: 'SFRounded-Regular', sans-serif;
  }
`;

export const CircleLoading = styled(AiOutlineLoading)`
  margin-top: 120px;

  align-self: center;

  font-size: 20px;
  color: ${colors.lightGreen};
  animation: ${rotation} 1s infinite;
`;
